module.exports = __webpack_public_path__ + "static/media/exercises-step2.84b7e1ba.png";